import React from 'react';
import { Link } from 'react-router-dom';
import { SiteLayout } from './site/SiteLayout';

export const NotFound = () => (
  <SiteLayout>
    <section style={{ position: 'relative', minHeight: '70vh', display: 'flex', alignItems: 'center', background: 'var(--ev-navy2)', overflow: 'hidden' }}>
      <img src={`${process.env.PUBLIC_URL}/img/toiture-modules.webp`} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: .25 }} />
      <div className="ev-wrap" style={{ position: 'relative', textAlign: 'center', width: '100%' }}>
        <div style={{ fontFamily: 'var(--ev-h)', fontWeight: 900, fontSize: 'clamp(5rem,16vw,10rem)', color: 'var(--ev-sun)', lineHeight: 1 }}>404</div>
        <h1 className="ev-h1" style={{ fontWeight: 900, color: '#fff', textTransform: 'uppercase', margin: '10px 0 16px' }}>Page introuvable</h1>
        <p style={{ color: 'rgba(255,255,255,.7)', maxWidth: 520, margin: '0 auto 32px', lineHeight: 1.8 }}>
          Cette page n'existe pas ou a été déplacée. Retrouvez nos prestations de sous-traitance photovoltaïque depuis l'accueil.
        </p>
        <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" className="ev-btn ev-btn-sun">← Retour à l'accueil</Link>
          <Link to="/contact" className="ev-btn ev-btn-ghost">Nous contacter</Link>
        </div>
      </div>
    </section>
  </SiteLayout>
);

export default NotFound;
